import get from 'lodash.get';
import Global from '../store/global-selectors';
import { emptyArray, emptyObject } from 'ui-components/default-props/empty';

class PrintModalHelperServiceClass {
  determinePackingSlipPrintingFormat(packingSlips, printDocumentFormat, cswPackingSlipTemplateId, printPackingSlipFormat) {
    if (printDocumentFormat) {
      return printDocumentFormat;
    }
    if (cswPackingSlipTemplateId) {
      const template = packingSlips.find((slip) => slip.packingSlipId === cswPackingSlipTemplateId);
      if (template) {
        return template;
      }
    }
    if (printPackingSlipFormat) {
      return printPackingSlipFormat;
    }

    return packingSlips[0];
  }

  determinePrinterForDocType(state, docType) {
    const printSetting = get(Global.selectPrintSettingsPrintSettings(state), docType) || emptyObject;
    if (printSetting.name === 'download') {
      return printSetting;
    }
    const allPrinters = Global.selectConnectPrinters(state) || emptyArray;
    const flattenedPrinters = allPrinters.reduce((acc, curr) => {
      return [...acc, ...curr.printers];
    }, []);
    const matchingPrinter = flattenedPrinters.find((printer) => printer.id === printSetting.id && !printer.disabled);
    return matchingPrinter;
  }
}

export const PrintModalHelperService = new PrintModalHelperServiceClass();
